import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const FieldLabel = ({ children, required, uppercase }) => (
  <Typography
    variant="caption"
    display="block"
    fontWeight={600}
    mb={0.5}
    sx={{
      textTransform: uppercase ? "uppercase" : "none",
      letterSpacing: uppercase ? "0.4px" : "normal",
      color: "#555",
    }}
  >
    {children}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </Typography>
);

FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  uppercase: PropTypes.bool,
};

FieldLabel.defaultProps = {
  required: false,
  uppercase: false,
};

export default FieldLabel;
